import * as React from "react";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import { Link } from "react-router-dom";
import * as moment from "moment";
import { isEmpty } from "lodash";

import { groupAuth } from "app/utils/authGroups";

import BOText from "app/components/BOComponents/BOText/BOText";
import PaymentSummaryBasicSection from "./Ops.Payments.Summary.Basic";
import HistoricalRefundRequests from "./Ops.Payments.Summary.HistoricalRefundRequests";

class Summary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      payserv: false,
      techops: false,
      data: null,
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.setState({
      payserv: groupAuth.hasAccessGroup(["Payserv/Admin", "Payserv/Staff"]),
      techops: groupAuth.hasAccessGroup(["TechOps/Admin"]),
    });

    this.loadData();
  }

  loadData() {
    this.props.payment_summary.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ data: fetchMoreResult.payments[0] });

        let time = moment(fetchMoreResult.payments[0].created_at);
        let weekTest = moment()
          .subtract(7, "days")
          .startOf("day")
          .isAfter(time);

        this.props.setHeader({
          title: "Ops > Payment",
          description: `${
            weekTest
              ? moment(fetchMoreResult.payments[0].created_at).calendar()
              : moment(fetchMoreResult.payments[0].created_at).fromNow()
          } - ${fetchMoreResult.payments[0].merchant.name}`,
        });
      },
    });
  }

  render() {
    const payment = this.state.data
      ? this.state.data
      : { merchant: {}, bank_card_change: {}, device: { user: {} }, card: {} };

    // Format Date
    const formatDate = (date) => {
      let DateObj = new Date(date);
      let formatFullDate = `${DateObj.getFullYear()}-${(
        "0" + (parseInt(DateObj.getMonth().toString(), 10) + 1).toString()
      ).slice(-2)}-${("0" + DateObj.getDate()).slice(-2)} ${(
        "0" + DateObj.getHours()
      ).slice(-2)}:${("0" + DateObj.getMinutes()).slice(-2)}:${(
        "0" + DateObj.getSeconds()
      ).slice(-2)}`;
      return <span>{formatFullDate}</span>;
    };

    //  STATUS FORMATING
    const formatStatus = (status) => {
      if (status === "completed") {
        return <i className="fa fa-check fa-lg" style={{ color: "green" }} />;
      } else if (status === "pending") {
        return (
          <i className="fa fa-hourglass fa-lg" style={{ color: "grey" }} />
        );
      } else if (status === "error") {
        return <i className="fa fa-times fa-lg" style={{ color: "red" }} />;
      } else {
        return null;
      }
    };
    const formatStatusColour = (status) => {
      if (status === "completed") {
        return "#ebffeb";
      } else if (status === "pending") {
        return "white";
      } else if (status === "error") {
        return "#ffebeb";
      } else {
        return "white";
      }
    };

    //  SECURE 3D
    const formatSecure3D = (status3D) => {
      if (status3D) {
        return <i className="fa fa-lock fa-lg" style={{ color: "green" }} />;
      } else {
        return <i className="fa fa-minus fa-lg" style={{ color: "red" }} />;
      }
    };

    // Summary
    const Summary = () => {
      if (payment) {
        return (
          <tbody>
            <tr style={{ backgroundColor: formatStatusColour(payment.status) }}>
              <td> {formatDate(payment.created_at)} </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/users/${payment.device.user.external_reference}/payments`}
                >
                  {payment.device.user.email}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.device.user.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/merchants/${payment.merchant.id}/payments`}
                >
                  {payment.merchant.name}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.merchant.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/devices/${payment.device.external_reference}/summary`}
                >
                  {payment.device.phone_number}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.device.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>
                <Link
                  className="blueLink"
                  to={`/snapscan/ops/payments/${payment.reference}/summary`}
                >
                  {payment.payment_strategy}
                </Link>
                <a
                  style={{ marginLeft: "6px" }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="blueLink"
                  href={payment.snapmin_url}
                >
                  <i className="fa fa-info-circle" />
                </a>
              </td>
              <td>{formatSecure3D(payment.secure3d_requested)}</td>
            </tr>
          </tbody>
        );
      } else {
        return null;
      }
    };

    return (
      <section>
        <div className="DetailTopBar">
          <BOText
            text="Summary"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/summary`}
            active="selected"
          />
          <BOText
            text="Details"
            tag="span"
            class="BODetailItem"
            link={`/snapscan/ops/payments/${this.props.match.params.id}/details`}
            active="selected"
          />
          <BOText
            text="Pay"
            tag="span"
            class={`BODetailItem ${this.state.payserv ? "show" : "hidden"}`}
            link={`/snapscan/ops/payments/${this.props.match.params.id}/pay`}
            active="selected"
          />
          <BOText
            text="Pay requests"
            tag="span"
            class={`BODetailItem ${this.state.payserv ? "show" : "hidden"}`}
            link={`/snapscan/ops/payments/${this.props.match.params.id}/pay_requests`}
            active="selected"
          />
        </div>

        <section className="padded">
          <div
            style={{
              height: "calc(100vh - 120px)",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              className="BOTable"
              cellPadding={0}
              cellSpacing={0}
            >
              <thead>
                <tr>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Date</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>User</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Merchant</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Device</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Payment</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>3DS</b>
                  </th>
                </tr>
              </thead>
              {Summary()}
            </table>

            <PaymentSummaryBasicSection
              data={payment}
              techops={this.state.techops}
              loadData={this.loadData}
              formatStatus={formatStatus}
              formatDate={formatDate}
            />

            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              cellPadding={0}
              cellSpacing={0}
              className="BOTable"
            >
              <thead>
                <tr>
                  <td colSpan={4}>
                    <h3
                      style={{
                        borderBottom: "1px solid rgb(204, 204, 204)",
                        fontWeight: 400,
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      Device
                    </h3>
                  </td>
                </tr>
                <tr>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>First name</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Surname</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Phone number</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Email</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td> {payment.device.first_name} </td>
                  <td> {payment.device.surname} </td>
                  <td>
                    <Link
                      className="blueLink"
                      to={`/snapscan/ops/devices/${payment.device.external_reference}/summary`}
                    >
                      {payment.device.phone_number}
                    </Link>
                    <a
                      style={{ marginLeft: "6px" }}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blueLink"
                      href={payment.device.snapmin_url}
                    >
                      <i className="fa fa-info-circle" />
                    </a>
                  </td>
                  <td>
                    <Link
                      className="blueLink"
                      to={`/snapscan/ops/users/${payment.device.user.external_reference}/payments`}
                    >
                      {payment.device.user.email}
                    </Link>
                    <a
                      style={{ marginLeft: "6px" }}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="blueLink"
                      href={payment.device.user.snapmin_url}
                    >
                      <i className="fa fa-info-circle" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

            <table
              style={{
                fontSize: "14px",
                paddingTop: "10px",
                width: "100%",
              }}
              cellPadding={0}
              cellSpacing={0}
              className={`BOTable ${
                payment.error_source !== null ? "" : "hidden"
              }`}
            >
              <thead>
                <tr>
                  <td colSpan={4}>
                    <h3
                      style={{
                        borderBottom: "1px solid rgb(204, 204, 204)",
                        fontWeight: 400,
                        display: "flex",
                        alignItems: "center",
                        paddingBottom: "10px",
                      }}
                    >
                      Error
                    </h3>
                  </td>
                </tr>
                <tr>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Source</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Reason</b>
                  </th>
                  <th className="align-l">
                    <b style={{ color: "#555" }}>Message</b>
                  </th>
                </tr>
              </thead>
              <tbody
                style={{
                  backgroundColor: "#ffebeb",
                }}
              >
                <tr>
                  <td>{payment.error_source} </td>
                  <td>{payment.error_reason} </td>
                  <td>{payment.error_message} </td>
                </tr>
              </tbody>
            </table>

            {!isEmpty(payment.list_refunds) && (
              <HistoricalRefundRequests data={payment.list_refunds} />
            )}
          </div>
        </section>
      </section>
    );
  }
}

// QUERIES
const paymentSummary = graphql(
  gql`
    query payment_summary($reference: String) {
      payments(reference: $reference) {
        created_at
        status
        pending_status
        payable_amount
        merchant_amount
        user_fee_amount
        payment_strategy
        reference
        receipt_url
        psp
        error_source
        error_reason
        error_message
        psp_reference
        snapmin_url
        secure3d_requested
        refundable
        cancelable
        list_refunds {
          id
          amount
          status
        }
        merchant {
          name
          id
          snapmin_url
        }
        bank_card_change {
          bin
          message
          country_code
          created_at
          status
          pending_status
        }
        device {
          created_at
          phone_number
          first_name
          surname
          snapmin_url
          external_reference
          user {
            email
            external_reference
            snapmin_url
          }
        }
      }
    }
  `,
  {
    name: "payment_summary",
    options(props: any) {
      return {
        variables: {
          reference: props.match.params.id,
        },
      };
    },
  }
);

export default compose<any>(paymentSummary)(Summary);
